var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-wrap"},[(_vm.nowTime < _vm.preBegin)?_c('st-sign'):(_vm.nowTime <= _vm.finalBegin)?_c('st-pre'):(_vm.nowTime > _vm.finalBegin)?_c('st-final'):_c('div',{staticClass:"txt-loading"},[_vm._v("数据加载中…")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }